import axios from "../services/api/api";

export const FETCH_CLASSES_BEGIN = "FETCH_CLASSES_BEGIN";
export const FETCH_CLASSES_FULFILLED = "FETCH_CLASSES_FULFILLED";
export const FETCH_CLASSES_REJECTED = "FETCH_CLASSES_REJECTED";

export function fetchClasses(schoolId) {
  return function (dispatch) {
    dispatch({
      type: FETCH_CLASS_BEGIN,
      payload: { loading: true },
    });
    return new Promise((resolve, reject) => {
      axios
        .get(`/Class/GetBySchoolId/${schoolId}`)
        .then((response) => {
          dispatch({
            type: FETCH_CLASSES_FULFILLED,
            payload: response.data.result,
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({ type: FETCH_CLASSES_REJECTED, payload: err });
          reject(err);
        });
    });
  };
}

export const FETCH_CLASS_BEGIN = "FETCH_CLASS_BEGIN";
export const FETCH_CLASS_FULFILLED = "FETCH_CLASS_FULFILLED";
export const FETCH_CLASS_REJECTED = "FETCH_CLASS_REJECTED";

export function fetchClass(classId) {
  return function (dispatch) {
    dispatch({
      type: FETCH_CLASS_BEGIN,
      payload: { loading: true },
    });
    return new Promise((resolve, reject) => {
      axios
        .get(`/Class/GetByClassId/${classId}`)
        .then((response) => {
          dispatch({
            type: FETCH_CLASS_FULFILLED,
            payload: response.data.result,
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({ type: FETCH_CLASS_REJECTED, payload: err });
          reject(err);
        });
    });
  };
}

export const DELETE_CLASS_BEGIN = "FETCH_CLASSES_BEGIN";
export const DELETE_CLASS_FULFILLED = "FETCH_CLASSES_FULFILLED";
export const DELETE_CLASS_REJECTED = "FETCH_CLASSES_REJECTED";

export function deleteClass(classId) {
  return function (dispatch) {
    dispatch({
      type: DELETE_CLASS_BEGIN,
      payload: { loading: true },
    });
    return new Promise((resolve, reject) => {
      axios
        .delete(`/Class/${classId}`)
        .then((response) => {
          dispatch({
            type: DELETE_CLASS_FULFILLED,
            payload: response.data.result,
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({ type: DELETE_CLASS_REJECTED, payload: err });
          reject(err);
        });
    });
  };
}
